import { object, string, array, InferType } from 'yup';

export const CareDocumentColumnSchema = object().shape({
  header: string().required('Header is required'),
  values: array().of(string().required()),
});

export type CareDocumentColumn = InferType<typeof CareDocumentColumnSchema>;
